<template>
  <div>
    <vs-popup :active.sync="showDnsPopup" title="Modification d'un nom de domaine">
      <div class="vx-row center_div">
        <!-- <div class="vx-col sm:w-1/4 w-full mb-2 flex">
          <vs-select autocomplete
                     v-model="modifiedDns.status"
                     class="w-full select-medium mr-2"
                     placeholder="Statut"
                     label="Statut">
            <vs-select-item :key="index"
                            :value="item.value"
                            :text="item.text"
                            v-for="(item, index) in sAdminStatusOptions"
                            class="w-full" />
          </vs-select>
        </div> -->
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Nom de domaine</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.host"
					:style="styleValidator('host')"
					@change="validateOne(modifiedDns.host, 'host')"
				/>
				<vx-tooltip v-if="validators['host'] && validators['host'].errText !== ''" :text="errText('host')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Port</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.port"
					:style="styleValidator('port')"
					@change="validateOne(modifiedDns.port, 'port')"
				/>
				<vx-tooltip v-if="validators['port'] && validators['port'].errText !== ''" :text="errText('port')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Login</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.login"
					:style="styleValidator('login')"
					@change="validateOne(modifiedDns.login, 'login')"
				/>
				<vx-tooltip v-if="validators['login'] && validators['login'].errText !== ''" :text="errText('login')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Mot de passe</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.pass"
					:style="styleValidator('pass')"
					@change="validateOne(modifiedDns.pass, 'pass')"
				/>
				<vx-tooltip v-if="validators['pass'] && validators['pass'].errText !== ''" :text="errText('pass')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Langue</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedDns.lang"
					class="w-full select-medium mr-2"
					:style="styleValidator('lang')"
					@change="validateOne(modifiedDns.lang, 'lang')"
				>
					<vs-select-item :key="index"
									:value="item.id.toString()"
									:text="item.name + ' (' + item.country + ')'"
									v-for="(item, index) in langList"
									class="w-full" />
				</vs-select>
				<vx-tooltip v-if="validators['lang'] && validators['lang'].errText !== ''" :text="errText('lang')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Domaine d'activité</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.domain_activity"
					:style="styleValidator('domain_activity')"
					@change="validateOne(modifiedDns.domain_activity, 'domain_activity')"
				/>
				<vx-tooltip v-if="validators['domain_activity'] && validators['domain_activity'].errText !== ''" :text="errText('domain_activity')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <!-- <div class="vx-col mb-2">
          <label for="" class="vs-input--label">Date d'achat</label>
          <vx-input-group class="w-full bottom">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span class="flex">
                  <vs-icon icon="calendar_today" size="small"></vs-icon>
                </span>
              </div>
            </template>
            <flat-pickr class="w-full"
                        v-model="modifiedDns.purchase_date"
                        :config="configEndDatePicker"
                        placeholder="Date d'achat" />
          </vx-input-group>
        </div> -->
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Durée renouvellement (en mois)</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.before_renew_duration"
					:style="styleValidator('before_renew_duration')"
					@change="validateOne(modifiedDns.before_renew_duration, 'before_renew_duration')"
				/>
				<vx-tooltip v-if="validators['before_renew_duration'] && validators['before_renew_duration'].errText !== ''" :text="errText('before_renew_duration')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
		  	<label for="" class="vs-select--label">Prix (€)</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedDns.price"
					:style="styleValidator('price')"
					@change="validateOne(modifiedDns.price, 'price')"
				/>
				<vx-tooltip v-if="validators['price'] && validators['price'].errText !== ''" :text="errText('price')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col mb-2">
          <vs-button color="primary" class="mt-2" @click="saveModifiedDns()">Modifier NDD</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce dns ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="acceptDelete()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="declineDelete()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <!--
    <vs-popup :active.sync="showNetlinkPopup" title="Modification d'un Netlink">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input
            class="w-full"
            placeholder="Lien acheté"
            label="Lien acheté"
            v-model="modifiedNetlink.url_bought"
            :danger="NetlinkValidationObjects.urlBoughtValidationObject.notValid"
            :danger-text="NetlinkValidationObjects.urlBoughtValidationObject.errText"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input
            class="w-full"
            placeholder="Landing page"
            label="Landing page"
            v-model="modifiedNetlink.landing_page"
            :danger="NetlinkValidationObjects.landingPageValidationObject.notValid"
            :danger-text="NetlinkValidationObjects.landingPageValidationObject.errText"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-select
            autocomplete
            v-model="modifiedNetlink.status"
            label="Status"
            class="w-full select-medium mr-2"
            placeholder="Statut"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in netlinkStatus"
              class="w-full"
            />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-select
            autocomplete
            v-model="modifiedNetlink.anchor_type"
            class="w-full select-medium mr-2"
            placeholder="Type ancre"
            label="Type ancre"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in anchorTypes"
              class="w-full"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
        <vs-select
          autocomplete
          v-model="modifiedNetlink.link_type"
          class="w-full select-medium mr-2"
          placeholder="Type lien"
          label="Type lien"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in linkTypes"
            class="w-full"
          />
        </vs-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()">Enregistrer Netlink</vs-button>
        </div>
      </div>
    </vs-popup> -->
    <div class="vx-row center_div t-border">
      <vs-table v-if="dns_list.length > 0" :data="dns_list" style="overflow: auto;">
          <template slot="thead">
        <vs-th>Nom de domaine</vs-th>
        <vs-th>Secteur d’activité</vs-th>
        <vs-th>Langue</vs-th>
        <vs-th>Login</vs-th>
        <vs-th>Mot de passe</vs-th>
        <vs-th>Prestataire</vs-th>
        <vs-th><vs-spacer/>Port</vs-th>
        <vs-th><vs-spacer/>Prix</vs-th>
        <!-- <vs-th><vs-spacer/>Date d’achat</vs-th> -->
        <vs-th><vs-spacer/>Renouvellement (mois)</vs-th>
        <vs-th></vs-th>
        <vs-th v-if="$acl.check('sadmin')"></vs-th>
    </template>

    <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(oneDns, index) in data">
          <vs-td :data="oneDns.host"><a class="hvr-underline hvr-underline-out" :href="oneDns.host" target="_blank">{{ oneDns.host }}</a></vs-td>
          <vs-td :data="oneDns.domain_activity">{{ oneDns.domain_activity }}</vs-td>
          <vs-td :data="oneDns.lang">{{ getLangIdToName(oneDns.lang) }}</vs-td>
          <vs-td :data="oneDns.login">{{ oneDns.login }}</vs-td>
          <vs-td :data="oneDns.pass">{{ oneDns.pass }}</vs-td>
          <vs-td :data="oneDns.provider_id">{{ getProviderIdToName(oneDns.provider_id) }}</vs-td>
          <vs-td :data="oneDns.port" style="text-align: right;">{{ oneDns.port }}</vs-td>
          <vs-td :data="oneDns.price" style="text-align: right;">{{ oneDns.price }}€</vs-td>
          <!-- <vs-td :data="oneDns.purchase_date" style="text-align: right;">{{ oneDns.purchase_date ? getDateToFrenchFormat(oneDns.purchase_date.substring(0,10)) : "" }}</vs-td> -->
          <vs-td :data="oneDns.before_renew_duration" style="text-align: right;">{{ oneDns.before_renew_duration }}</vs-td>
<!--
          <vs-td :data="oneDns.anchor_type">{{ getNetlinkAnchorType(oneDns.anchor_type) }}</vs-td>
          <vs-td :data="oneDns.link_type">{{ getNetlinkLinkType(oneDns.link_type) }}</vs-td>
          <vs-td :data="oneDns.purchase_id"> {{ oneDns.creation_date ? getDateToFrenchFormat(oneDns.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(oneDns.purchase_id)) }}</vs-td>
          <vs-td :data="oneDns.status">
            <vs-chip
              style="width: 80px"
              :color="getNetlinkStatusColor(oneDns.status)"
              class="ml-2"
              >{{
              getNetlinkStatus(oneDns.status)
            }}</vs-chip></vs-td> -->
          <vs-td>
              <vx-tooltip text="Modifier" position="top">
              <vs-button
                  size="large"
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  @click="modifyDns(oneDns, index)"
              ></vs-button>
              </vx-tooltip>
          </vs-td>
          <vs-td v-if="$acl.check('sadmin')">
              <vx-tooltip text="Effacer" position="top">
              <vs-button
                  size="large"
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click="displayValidationPopup(oneDns, index)"
              ></vs-button>
              </vx-tooltip>
          </vs-td>
        </vs-tr>
    </template>
    <!-- <vs-td><vs-button color="primary" @click="modifyNetlink(tr)" :disabled="disable">Modifier</vs-button></vs-td>
            <vs-td><vs-button color="primary" @click="displayValidationPopup(tr.id)" :disabled="disable">Supprimer</vs-button></vs-td>
          </vs-tr>
        </template> -->
      </vs-table>
    </div>
    <div v-if="!showNewDns" class="vx-row center_div">
      <vs-button
        class="float-right"
        radius
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="showNewDnsForm"
      ></vs-button>
    </div>
    <!-- <vs-th>Secteur d’activité</vs-th>
        <vs-th>Langue</vs-th>
        <vs-th>Login</vs-th>
        <vs-th>Mot de passe</vs-th>
        <vs-th>Prestataire</vs-th>
        <vs-th>Port</vs-th>
        <vs-th>Prix</vs-th>
        <vs-th>Date d’achat</vs-th>
        <vs-th>Durée renouvellement</vs-th> -->
    <div v-if="showNewDns" class="vx-row center_div">
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Nom de domaine</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.host"
					:style="styleValidator('host')"
					@change="validateOne(dns.host, 'host')"
				/>
				<vx-tooltip v-if="validators['host'] && validators['host'].errText !== ''" :text="errText('host')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Port</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.port"
					:style="styleValidator('port')"
					@change="validateOne(dns.port, 'port')"
				/>
				<vx-tooltip v-if="validators['port'] && validators['port'].errText !== ''" :text="errText('port')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Login</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.login"
					:style="styleValidator('login')"
					@change="validateOne(dns.login, 'login')"
				/>
				<vx-tooltip v-if="validators['login'] && validators['login'].errText !== ''" :text="errText('login')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Mot de passe</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.pass"
					:style="styleValidator('pass')"
					@change="validateOne(dns.pass, 'pass')"
				/>
				<vx-tooltip v-if="validators['pass'] && validators['pass'].errText !== ''" :text="errText('pass')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Langue</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="dns.lang"
					class="w-full select-medium mr-2"
					:style="styleValidator('lang')"
					@change="validateOne(dns.lang, 'lang')"
				>
				<vs-select-item
					:key="index"
					:value="item.id.toString()"
					:text="item.name + ' (' + item.country + ')'"
					v-for="(item, index) in langList"
					class="w-full"
				/>
				</vs-select>
				<vx-tooltip v-if="validators['lang'] && validators['lang'].errText !== ''" :text="errText('lang')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Domaine d'activité</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.domain_activity"
					:style="styleValidator('domain_activity')"
					@change="validateOne(dns.domain_activity, 'domain_activity')"
				/>
				<vx-tooltip v-if="validators['domain_activity'] && validators['domain_activity'].errText !== ''" :text="errText('domain_activity')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
      <!-- <div class="vx-col mb-2">
      <vx-input-group
        class="w-full bottom"
      >
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span class="flex"
                ><vs-icon icon="calendar_today" size="small"></vs-icon
              ></span>
            </div>
          </template>
          <flat-pickr
            class="w-full"
            v-model="dns.purchase_date"
            :config="configEndDatePicker"
            placeholder="Date d'achat"
          />
        </vx-input-group>
      </div> -->
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Durée renouvellement (en mois)</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.before_renew_duration"
					:style="styleValidator('before_renew_duration')"
					@change="validateOne(dns.before_renew_duration, 'before_renew_duration')"
				/>
				<vx-tooltip v-if="validators['before_renew_duration'] && validators['before_renew_duration'].errText !== ''" :text="errText('before_renew_duration')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col mb-2">
			<label for="" class="vs-select--label">Prix (€)</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="dns.price"
					:style="styleValidator('price')"
					@change="validateOne(dns.price, 'price')"
				/>
				<vx-tooltip v-if="validators['price'] && validators['price'].errText !== ''" :text="errText('price')" class="ml-3">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
		<div class="vx-col">
			<vs-button color="primary" class="mt-2" @click="newDns()" :disabled="disable">Ajouter Dns</vs-button>
		</div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue'
import Dns from "@/entities/Dns";
// import NetlinkModifyPopup from "@/components/popups/NetlinkModifyPopup"
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Validator from "@/entities/Validator";
import validatorMixin from "@/mixins/validatorMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";


export default {
	name: "DnsPopupTable",
	components: {flatPickr, VxTooltip},
	mixins: [dbFieldConvertor, utilsMixin, validatorMixin],
	props: {
		purchaseId: Number,
		providerId: Number,
		price: Number,
		/*
		 * societyId: Number,
		 * showNetlinkBuyer: Boolean,
		 */
		disable: Boolean
	},
	data() {
		return {
			dns: Dns.getFormFields(),
			modifiedDns: Dns.getFormFields(),
			modifiedDnsIndex: null,
			dns_list: [],
			/*
			 * netlinkStatus: [
			 *   {text:"Acquis", value: 0},
			 *   {text:"Refusé", value: 2},
			 *   {text:"Terminé", value: 3}
			 * ],
			 * anchorTypes: [
			 *   {text:"Brand et Générique", value: 0},
			 *   {text:" Semi optimisée", value: 1},
			 *   {text:"Générique", value: 2},
			 * ],
			 */
			langList: [
				{name: "Français", country: "France", id: 1},
				{name: "Anglais", country: "USA", id: 2},
				{name: "Anglais", country: "UK", id: 3},
				{name: "Chinois simplifié", country: "RPC", id: 4},
				{name: "Japonais", country: "Japon", id: 5},
				{name: "Coréen", country: "Corée du Sud", id: 6},
			],

			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y"
			},

			newDate: null,
			newHost: "",
			newLang: null,
			newLogin: "",
			newPass: "",
			newPort: 80,
			newRenewDuration: 0,

			showDnsPopup: false,
			showNetlinkPopup: false,
			showNewDns: true,
			showValidationPopup: false,
			selectedDns: null,
			dnsTableLock: false,
			sAdminStatusOptions: [
				{text: "Actif", value: 1},
				/*
				 * { text: "A\u00a0Valider", value: 2 },
				 * { text: "En\u00a0pause", value: 3 },
				 */
				{text: "Terminé", value: 4},
				/*
				 * { text: "Annulé", value: 5 },
				 */
			],
			validators: {},
			check: true,
			/*
			 * Validator Objects
			 * NetlinkValidationObjects: {
			 *   urlBoughtValidationObject: {
			 *     valid: false,
			 *     notValid: false,
			 *     validText: null,
			 *     errText: null,
			 *     constraintName: "websiteConstraint",
			 *     required: true
			 *   },
			 *   landingPageValidationObject: {
			 *     valid: false,
			 *     notValid: false,
			 *     validText: null,
			 *     errText: null,
			 *     constraintName: "websiteConstraint",
			 *     required: true
			 *   },
			 * },
			 * ModifiedNetlinkValidationObjects: {
			 *   urlBoughtValidationObject: {
			 *     valid: false,
			 *     notValid: false,
			 *     validText: null,
			 *     errText: null,
			 *     constraintName: "websiteConstraint",
			 *     required: true
			 *   },
			 *   landingPageValidationObject: {
			 *     valid: false,
			 *     notValid: false,
			 *     validText: null,
			 *     errText: null,
			 *     constraintName: "websiteConstraint",
			 *     required: true
			 *   },
			 * },
			 */
		};
	},
	created() {
		this.$store.dispatch("getAllNetlink");
		if(this.$props.disable){
			this.dnsTableLock = this.$props.disable;
		}
	},
	mounted() {
		if(this.$props.purchaseId){
			this.checkPurchaseHaveDns();
		}
		/*
		 * else if(this.$props.societyId){
		 *   this.checkSocietyHaveNetlink()
		 * }
		 */
	},
	computed: {
		dnss: () => {
			return store.state.dns;
		},
		providers: () => {
			return store.state.providers;
		}
	},
	watch: {
		/*
		 * newAnchorType: function(){
		 *   //console.log("newAnchorType")
		 *   this.dns.anchorType = this.newAnchorType
		 * },
		 * newLandingPage: function(){
		 *   //console.log("newLandingPage")
		 *   this.dns.landingPage = this.newLandingPage
		 * },
		 * newHost: function(){
		 *   //console.log("newHost")
		 *   this.dns.urlBought = this.newHost
		 * },
		 * newLinkType: function(){
		 *   //console.log("newLinkType")
		 *   this.dns.linkType = this.newLinkType
		 * },
		 * newStatus: function(){
		 *   //console.log("newStatus")
		 *   this.dns.status = this.newStatus
		 * },
		 */
		dnss: function(){
			//console.log("dnss updated");
			if(this.$props.purchaseId){
				this.dns_list = this.dnss.filter(dns => dns.purchase_id == this.$props.purchaseId);
			}
			/*
			 * else{
			 *   this.dns_list = this.dnss.filter(dns => dns.society_id == this.$props.societyId)
			 * }
			 */
		},
		purchaseId: function(data){
			//console.log("DNS purchase_id updated");
			this.dns_list = this.dnss.filter(dns => dns.purchase_id == data);
		},
		societyId: function(){
			/*
			 * //console.log("society_id updated")
			 * if(!this.purchaseId){
			 *   //console.log("No purchase_id:", this.purchaseId)
			 *   this.dns_list = this.dnss.filter(dns => dns.society_id == this.$props.societyId)
			 * }
			 */
		},
		/*
		 * dns_list: function(){
		 *   //console.log("dns_list updated")
		 *   this.$emit('dns-update', this.dns_list.length)
		 * },
		 */
	},
	methods: {
		updateDnsForPurchase(){
			return new Promise((resolve, reject) => {
				//console.log("this.dns_list", this.dns_list);
				Dns.updateAllForPurchase(this.$props.purchaseId, this.dns_list, (err, result) => {
					if(result){
						resolve(result);
					}
					if(err){
						reject(err);
					}
				});
			});
		},
		saveModifiedDns(){
			this.check = true;
			let fields = ["host", "port", "login", "pass", "lang", "domain_activity", "before_renew_duration", "price"];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = this.modifiedDns[fields[i]];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"price":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				case"host":
					constname = "domaineConstraint";
					break;
				case"login":
				case"pass":
				case"domain_activity":
					constname = "nameConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				this.modifiedDns[fields[i]] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.modifiedDns.price = String(this.modifiedDns.price).replace(",", ".");
				this.modifiedDns.price = Number(this.modifiedDns.price);
				/*
				 * this.modifiedDns
				 * this.modifiedDnsIndex
				 */
				this.dns_list.splice(this.modifiedDnsIndex, 1, this.modifiedDns);
				this.showDnsPopup = false;
			}
		},
		modifyDns(dns, index){
			//console.log(dns);
			//Initialisation des données pour le popup
			this.modifiedDnsIndex = index;
			this.modifiedDns = null; // Always reset data before assigning it
			let dnsData = JSON.parse(JSON.stringify(dns));
			this.modifiedDns = new Dns(dnsData);
			this.showDnsPopup = true;
		},
		getProviderIdToName(provider_id){
			// let provider_name = ""
			let provider = this.providers.find(provider => provider.id == provider_id);
			let provider_name = provider ? provider.society : "";
			return provider_name;
		},

		getLangIdToName(lang_id){
			// let provider_name = ""
			let lang = this.langList.find(lang => lang.id == lang_id);
			let lang_name = lang ? `${lang.name} (${lang.country})` : "";
			return lang_name;
		},
		getDnsData(){
			return this.dns;
		},
		showNewDnsForm(){
			this.showNewDns = true;
		},
		validateOne(val, name){
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			switch(name){
			case"price":
				value ? value = String(val) : "";
				constname = "priceConstraint";
				break;
			case"host":
				constname = "domaineConstraint";
				break;
			case"login":
			case"pass":
			case"domain_activity":
				constname = "nameConstraint";
				break;
			default:
				value ? value = String(val) : "";
				value == null ? value = "" : "";
				constname = "isNumberConstraint";
				break;
			}
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},
		newDns(){
			this.check = true;
			let fields = ["host", "port", "login", "pass", "lang", "domain_activity", "before_renew_duration", "price"];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = this.dns[fields[i]];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"price":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				case"host":
					constname = "domaineConstraint";
					break;
				case"login":
				case"pass":
				case"domain_activity":
					constname = "nameConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				this.dns[fields[i]] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";

				//console.log(this.validators[fields[i]]);
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.dns.price = String(this.dns.price).replace(",", ".");
				this.dns.price = Number(this.dns.price);

				return new Promise((resolve, reject) => {
					/*
					 * if(!this.checkAllRequiredFields()){
					 *   this.$vs.notify({
					 *     title: "Echec",
					 *     text: "Tous les champs nécessaires ne sont pas remplis."
					 *   });
					 *   return false
					 * }
					 * if(!this.checkAllFieldsError()){
					 *   this.$vs.notify({
					 *     title: "Echec",
					 *     text: "Certains champs contiennent une valeur erronée."
					 *   });
					 *   return false
					 * }
					 */

					/*
					 * this.dns.landingPage = this.dns.landingPage;
					 * this.dns.urlBought = this.dns.urlBought;
					 */

					// //console.log("url test",this.dns.urlBought, this.dns.landingPage )


					//console.log("this.$props.purchaseId", this.$props.purchaseId);
					if(this.$props.purchaseId){
						//console.log(this.$props.purchaseId);
						this.dns.purchase_id = this.$props.purchaseId;
					}
					if(this.$props.providerId){
						//console.log(this.$props.providerId);
						this.dns.provider_id = this.$props.providerId;
					}


					/*
					 * if(this.$props.price){
					 *   //console.log(this.$props.price)
					 *   this.dns.price = this.$props.price
					 * }
					 */

					/*
					 * //console.log("this.$props.societyId", this.$props.societyId)
					 * if(this.$props.societyId){
					 *   //console.log(this.$props.societyId)
					 *   this.dns.society_id = this.$props.societyId
					 * }
					 * let formatedDate = this.dns.purchase_date.split('/').reverse().join('-')
					 * this.dns.purchase_date = formatedDate
					 * this.dns.renew_date = formatedDate
					 */
					let newDns = new Dns(this.dns);
					//console.log(newDns);
					this.dns_list.push(newDns);
					this.showNewDns = false;
					resolve(newDns);
					/*
					 * newDns.create((err, res) => {
					 *   if(err){
					 *     //console.log(err)
					 *     reject(err)
					 *   }
					 *   if(res) {
					 *     //console.log(res)
					 *     this.$store.dispatch("getAllDns");
					 *     resolve(res)
					 *   }
					 * })
					 */
				});
			}
		},

		getPurchasePrice(){
			return new Promise((resolve, reject) => {
				let price = 0;
				for(let dns of this.dns_list){
					price += parseFloat(dns.price);
				}
				resolve(price);
			});
		},

		submitDns(dns){
			return new Promise((resolve, reject) => {
				//console.log("New Dns", dns);
				dns.create((err, res) => {
					if(err){
						//console.log("Err Dns", err);
						reject(err);
					}
					if(res){
						resolve(res);
					}
				});
			});
		},

		submitAllDns(purchase_id, purchase_date, provider_id){
			return new Promise((resolve, reject) => {
				let requests = [];
				//console.log(this.dns_list);
				for(let dns of this.dns_list){
					//console.log("Dns of list:", dns);
					dns.purchase_id = purchase_id;
					dns.purchase_date = purchase_date;
					dns.renew_date = purchase_date;
					dns.provider_id = provider_id;
					requests.push(this.submitDns(dns));
				}
				Promise.all(requests)
					.then(responses => {
						//console.log("All Dns Results:", responses);
						resolve(responses);
					})
					.catch(err => {
						//console.log("DNS Errors:", err);
					});
			});
		},

		/*
		 * deleteDns(){
		 *   // //console.log(dnsId)
		 *   this.dns_list.splice(this.modifiedDnsIndex,1)
		 *   this.modifiedDns = null
		 *   this.modifiedDnsIndex = null
		 */

		/*
		 *   // Dns.delete(dnsId, (err, res) => {
		 *   //   if(err) //console.log(err)
		 *   //   if(res) {
		 *   //     this.$store.dispatch("getAllDns");
		 *   //     //console.log(res)
		 *   //   }
		 *   // })
		 * },
		 */

		acceptDelete(){
			this.showValidationPopup = false;
			let dnsIndex = this.modifiedDnsIndex;
			this.dns_list.splice(dnsIndex, 1);
		},

		declineDelete(){
			this.modifiedDns = null;
			this.modifiedDnsIndex = null;
			this.showValidationPopup = false;
		},

		displayValidationPopup(dns, index){
			this.modifiedDns = dns;
			this.modifiedDnsIndex = index;
			this.showValidationPopup = true;
		},

		/*
		 * modifyNetlink(dns){
		 *   //console.log(dns)
		 *   //Initialisation des données pour le popup
		 *   this.modifiedNetlink = null; // Always reset data before assigning it
		 *   this.modifiedNetlink = JSON.parse(JSON.stringify(dns));
		 *   this.showNetlinkPopup = true;
		 * },
		 * saveModifiedNetlink(){
		 *   // if(!this.checkAllModifiedRequiredFields()){
		 *   //   this.$vs.notify({
		 *   //     title: "Echec",
		 *   //     text: "Certains champs contiennent une valeur erronée."
		 *   //   });
		 *   //   return false
		 *   // }
		 *   // if(!this.checkModifiedAllFieldsError()){
		 *   //   this.$vs.notify({
		 *   //     title: "Echec",
		 *   //     text: "Certains champs contiennent une valeur erronée."
		 *   //   });
		 *   //   return false
		 *   // }
		 */

		/*
		 *   let re = new RegExp('([T|Z])', 'g')
		 *   if(this.modifiedNetlink.creation_date) this.modifiedNetlink.creation_date = this.modifiedNetlink.creation_date.replace(re, " ")
		 *   let params = {
		 *     id: this.modifiedNetlink.id,
		 *     urlBought: this.modifiedNetlink.url_bought,
		 *     anchorType: this.modifiedNetlink.anchor_type,
		 *     landingPage: this.modifiedNetlink.landing_page,
		 *     status: this.modifiedNetlink.status,
		 *     linkType: this.modifiedNetlink.link_type,
		 *     domainAuthority: this.modifiedNetlink.domain_authority,
		 *     pageAuthority: this.modifiedNetlink.page_authority,
		 *     trustFlow: this.modifiedNetlink.trust_flow,
		 *     citationFlow: this.modifiedNetlink.citation_flow,
		 *     externalLinks: this.modifiedNetlink.external_links,
		 *     refDomains: this.modifiedNetlink.ref_domains,
		 *     purchase_id: this.modifiedNetlink.purchase_id,
		 *     society_id: this.modifiedNetlink.society_id,
		 *     creation_date: this.modifiedNetlink.creation_date,
		 *   }
		 *   //console.log("params")
		 *   //console.log(params)
		 *   let savedModifiedNetlink = new Netlink(params)
		 *   //console.log(savedModifiedNetlink)
		 *   savedModifiedNetlink.update((err, res) => {
		 *     if(err) //console.log(err)
		 *     if(res) {
		 *       //console.log(res)
		 *       this.$store.dispatch("getAllNetlink");
		 *       this.showNetlinkPopup = false
		 *     }
		 *   })
		 * },
		 */
		checkPurchaseHaveDns(){
			let dnsFiltered = this.dnss.filter(dns => dns.purchase_id == this.$props.purchaseId);
			/*
			 * //console.log("checkPurchaseHaveDns")
			 * //console.log(this.$props.purchaseId)
			 * //console.log(this.dnss)
			 * //console.log(dnsFiltered)
			 */
			if(dnsFiltered.length > 0){
				this.dns_list = dnsFiltered;
			}
		},

		/*
		 * checkSocietyHaveNetlink(){
		 *   let dnsFiltered = this.dnss.filter(dns => dns.purchase_id == this.$props.purchaseId)
		 *   //console.log("checkSocietyHaveNetlink")
		 *   //console.log(this.$props.purchaseId)
		 *   //console.log(this.dnss)
		 *   //console.log(dnsFiltered)
		 *   if(dnsFiltered.length > 0){
		 *     this.dns_list = dnsFiltered
		 *   }
		 * },
		 */

		// /**
		//  * Checks if landing page link is valid
		//  */
		// checkLandingPage(){
		//   this.checkHandler(this.dns.landingPage, this.NetlinkValidationObjects.landingPageValidationObject)
		// },

		// /**
		//  * Checks if urlBought link is valid
		//  */
		// checkUrlBought(){
		//   this.checkHandler(this.dns.urlBought, this.NetlinkValidationObjects.urlBoughtValidationObject)
		// },

		// /**
		//  * Checks if landing page link is valid
		//  */
		// checkModifiedLandingPage(){
		//   this.checkHandler(this.modifiedNetlink.landingPage, this.ModifiedNetlinkValidationObjects.landingPageValidationObject)
		// },

		// /**
		//  * Checks if urlBought link is valid
		//  */
		// checkModifiedUrlBought(){
		//   this.checkHandler(this.modifiedNetlink.urlBought, this.ModifiedNetlinkValidationObjects.urlBoughtValidationObject)
		// },

		// /**
		//  * Check if all required fields for COntract are valid
		//  * @return true if all are valid else return false if at least one is not valid
		//  */
		// checkAllRequiredFields(){
		//   let requiredFieldsOk = true;

		/*
		 *   Object.entries(this.NetlinkValidationObjects).forEach(entry => {
		 *     const [key, value] = entry;
		 *     if(value.required && !value.valid && requiredFieldsOk){
		 *       requiredFieldsOk = value.valid;
		 *     }
		 *   })
		 */

		/*
		 *   return requiredFieldsOk;
		 * },
		 */

		// /**
		//  * Check if all required fields for COntract are valid
		//  * @return true if all are valid else return false if at least one is not valid
		//  */
		// checkAllFieldsError(){
		//   let fieldsErrorOk = true;

		/*
		 *   Object.entries(this.NetlinkValidationObjects).forEach(entry => {
		 *     const [key, value] = entry;
		 *     if(value.notValid && fieldsErrorOk){
		 *       fieldsErrorOk = false;
		 *     }
		 *   })
		 */

		/*
		 *   return fieldsErrorOk;
		 * },
		 */

		// /**
		//  * Check if all required fields for COntract are valid
		//  * @return true if all are valid else return false if at least one is not valid
		//  */
		// checkAllModifiedRequiredFields(){
		//   let requiredFieldsOk = true;

		/*
		 *   Object.entries(this.NetlinkValidationObjects).forEach(entry => {
		 *     const [key, value] = entry;
		 *     if(value.required && !value.valid && requiredFieldsOk){
		 *       requiredFieldsOk = value.valid;
		 *     }
		 *   })
		 */

		/*
		 *   return requiredFieldsOk;
		 * },
		 */

		// /**
		//  * Check if all required fields for COntract are valid
		//  * @return true if all are valid else return false if at least one is not valid
		//  */
		// checkAllModifiedFieldsError(){
		//   let fieldsErrorOk = true;

		/*
		 *   Object.entries(this.NetlinkValidationObjects).forEach(entry => {
		 *     const [key, value] = entry;
		 *     if(value.notValid && fieldsErrorOk){
		 *       fieldsErrorOk = false;
		 *     }
		 *   })
		 */

		/*
		 *   return fieldsErrorOk;
		 * },
		 */

	},
};
</script>
<style scoped>

</style>
